import { render } from "./RimacomiWithdrawCustom.vue?vue&type=template&id=7bf921f7&scoped=true&ts=true"
import script from "./RimacomiWithdrawCustom.vue?vue&type=script&lang=ts"
export * from "./RimacomiWithdrawCustom.vue?vue&type=script&lang=ts"

import "./RimacomiWithdrawCustom.vue?vue&type=style&index=0&id=7bf921f7&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src599522923/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bf921f7"]])

export default __exports__